// extracted by mini-css-extract-plugin
module.exports = {"mobileLayout":"CarComparisonMobileTable_mobileLayout__m__28","shimmer":"CarComparisonMobileTable_shimmer__ULT7_"};